<template>
  <div class="pagination-container">
    <div class="pagination">
      <div class="buttons">
        <!-- <button id="pagination-first" @click="changePage(1)" :disabled="current === 1">
          First
        </button> -->
        <button v-if = "visiblePages.length > 0" id="pagination-previous" @click="prevPage" :disabled="current === 1">
          <img src="@/assets/chrevon-left.svg" alt="Next" class="button-image" />
        </button>
        <!-- <button v-if=" current !== 1 "  id="pagination-page1" @click="changePage(1)">1</button> -->
        <button v-if="visiblePages[0] > 1"  id="pagination-page1" @click="changePage(1)"
        :class="{ active: current === 1 }">
        1</button>

        <template v-if="visiblePages[0] > 2">
          <span class="ellipsis">...</span>
        </template>
        <button v-for="page in visiblePages" :key="page" id="pagination-page{{page}}" @click="changePage(page)"
          :class="{ active: current === page }">
          {{ page }}
        </button>
        <template v-if="visiblePages[visiblePages.length - 1] < totalPages - 1">
          <span class="ellipsis">...</span>
        </template>
        <button  v-if="visiblePages[visiblePages.length-1] < totalPages" :id="'pagination-page' + totalPages" @click="changePage(totalPages)"
        :class="{ active: current === totalPages }"
        >
          {{ totalPages }}
        </button>
        <button v-if = "visiblePages.length > 0" id="pagination-next" @click="nextPage" :disabled="current === totalPages">
          <img src="@/assets/chrevon-right.svg" alt="Next" class="button-image" />
        </button>
        <!-- <button id="pagination-last" @click="changePage(totalPages)" :disabled="current === totalPages">
          Last
        </button> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    total: {
      type: Number,
      required: true,
    },
    current: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      required: true,
    },
    visiblePageCount: {
      type: Number,
      required: false,
      default: 5, // default value if not provided
    },
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.perPage);
    },
    visiblePages() {
      const pages = [];
      const range = Math.floor(this.visiblePageCount / 2);
      let start = Math.max(1, this.current - range);
      let end = Math.min(this.totalPages, this.current + range);

      // if (end - start + 1 < this.visiblePageCount) {
      //   if (start === 1) {
      //     end = Math.min(this.totalPages, start + this.visiblePageCount - 1);
      //   } else if (end === this.totalPages) {
      //     start = Math.max(1, end - this.visiblePageCount + 1);
      //   }
      // }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      return pages;
    },
  },
  methods: {
    prevPage() {
      if (this.current > 1) {
        this.$emit('page-changed', this.current - 1);
      }
    },
    nextPage() {
      if (this.current < this.totalPages) {
        this.$emit('page-changed', this.current + 1);
      }
    },
    changePage(page) {
      this.$emit('page-changed', page);
    },
  },
};
</script>

<style scoped>
.pagination-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 80px;
  margin-bottom: 160px;
  width: 100%;
  gap: 10px;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
}

.buttons {
  display: flex;
  align-items: center;
  gap: 5px;
}

button {
  width: 40px;
  /* Set the width to define the circle's size */
  height: 40px;
  /* Set the height equal to the width */
  border: none;
  /* Remove border for a clean circle */
  background-color: white;
  /* Background color of the button */
  color: var(--green03);
  /* Text color */
  cursor: pointer;
  border-radius: 50%;
  /* Makes the button a circle */
  display: flex;
  /* Use flexbox to center text */
  justify-content: center;
  /* Horizontally center text */
  align-items: center;
  /* Vertically center text */
  font-family: Inter, sans-serif;
  /* Font family */
  font-size: 14px;
  /* Font size */
  font-weight: 700;
  /* Font weight */
  line-height: 21.56px;
  /* Line height */
  text-align: center;
  /* Ensure text alignment */
}

button.active {
  font-weight: bold;
  background-color: var(--green03);
  /* Active button background color */
  color: #FFFFFF;
}

button:disabled {
  cursor: not-allowed;
  color: var(--green03);
  opacity: 0.5;
}

.ellipsis {
  padding: 8px 15px;
  color: var(--green03);
  font-size: 14px;
}


.button-image {
  width: 20px; /* Adjust the size as needed */
  height: 20px; /* Adjust the size as needed */
  /* filter: invert(0.5) sepia(1) saturate(5) hue-rotate(90deg); Example filter to change color */
  filter: invert(27%) sepia(100%) saturate(1000%) hue-rotate(90deg) brightness(90%); /* Adjust filter to match #008842 */
   /* Set the color using the CSS variable */
  /* filter: invert(50%) sepia(100%) saturate(500%) hue-rotate(90deg); Example filter to change color */

}

.button-image:hover {
  filter: invert(0.5) sepia(1) saturate(5) hue-rotate(180deg);
  /* filter: invert(0.5) sepia(100%) saturate(1000%) hue-rotate(180deg) brightness(70%); Adjust filter to match #008842 on hover */

}

/* button:first-child {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}

button:last-child {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
} */
</style>
